import React, { Component } from 'react';
import { LenderRow } from '../components/LenderRow.tsx';
import { MortgageReason } from '../helpers/Enums.js';
import { PreviousButton } from '../components/PreviousButton.tsx';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
    showPrev: boolean;
}

export class Switcher extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Let's keep things simple, why do you want to switch?</h1>
                <p>Select your primary reason so that we can source your best-fit mortgage, <strong>at no cost to you!</strong></p>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column3'>
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.ReducePayments.toString())}>
                                <div>
                                    <div><i className='std fa fa-credit-card' /></div>
                                    <div><span className='b'>To reduce my<br/>Payments</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column3'>
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.LockIn.toString())}>
                                <div>
                                    <div><i className='std fa fa-lock' /></div>
                                    <span className='b'>To lock in a<br/>Low Rate</span>
                                </div>
                            </div>
                        </div>
                        <div className='column3'>
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.TopUp.toString())}>
                                <div >
                                    {/* For some reason the paint brush font-awesome icon wasn't available, so grabbed the SVG from the free icons */}
                                    <div><i className='svg'><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512" fill='currentcolor'><path d="M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"/></svg></i></div>
                                    <span className='b'>To release equity for<br/>Home Improvements</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.showPrev &&
                        <div className='row'>
                            <div className='button-group'>
                                <PreviousButton onClick={() => this.props.prevStep()} />
                            </div>
                        </div>
                    }
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header >
        );
    }
}
